// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrls: {
    sso: 'https://sso.compassmanager.com',
    rbac: 'https://adams.compassmanager.com',
    oauthLambda: 'https://vzn2x2as6h.execute-api.us-east-1.amazonaws.com/prod/oauth2.0',
    oData: 'https://api.cg-truedata.com/OData/v1/',
    api: 'https://alb.cg-truedata.com/',
     metadata: 'https://api.cg-truedata.com/api/truemetadata',
    redirectUri: 'https://vzn2x2as6h.execute-api.us-east-1.amazonaws.com/prod/oauth2.0'
  },
  omsConfig: {
    ssoClientId: '6QIcxk80J6nDKMJ3xAECR6CdoII3q5A2',
    clientId: '6QIcxk80J6nDKMJ3xAECR6CdoII3q5A2',
    clientSecret: '5ew6DZ8rJGfa3KmD292CerhghXqhcY6d',
    authUrl: 'https://sso.compassmanager.com/oauth2.0/accessToken',
    grantType: 'client_credentials'
  }
};
